export default __webpack_public_path__ + "static/media/ProximaNova-Semibold.22781785.otf";